import { render, staticRenderFns } from "./AttachmentBtnBase.vue?vue&type=template&id=238c2f32&scoped=true&"
import script from "./AttachmentBtnBase.vue?vue&type=script&lang=js&"
export * from "./AttachmentBtnBase.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentBtnBase.vue?vue&type=style&index=0&id=238c2f32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238c2f32",
  null
  
)

export default component.exports